import {
  addObj,
  getAll,
  searchByName,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  addProcessRemark,
  uploadMaintainPicture,
  removeMaintainPicture
} from '@/api/positioningdevicetypeserv'

export default {
  state: {
    state_PositioningDeviceType_AddObjResult: null,
    state_PositioningDeviceType_GetAllResult: null,
    state_PositioningDeviceType_SearchByNameResult: null,
    state_PositioningDeviceType_GetPageResult: null,
    state_PositioningDeviceType_GetDetailResult: null,
    state_PositioningDeviceType_ModifyObjResult: null,
    state_PositioningDeviceType_DeleteObjResult: null,
    state_PositioningDeviceType_AddProcessRemarkResult: null,
    state_PositioningDeviceType_UploadMaintainPictureResult: null,
    state_PositioningDeviceType_RemoveMaintainPictureResult: null
  },
  mutations: {
    SET_POSITIONINGDEVICETYPE_ADDOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_AddObjResult = rst
    },
    SET_POSITIONINGDEVICETYPE_GETALL_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_GetAllResult = rst
    },
    SET_POSITIONINGDEVICETYPE_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_SearchByNameResult = rst
    },
    SET_POSITIONINGDEVICETYPE_GETPAGE_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_GetPageResult = rst
    },
    SET_POSITIONINGDEVICETYPE_GETDETAIL_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_GetDetailResult = rst
    },
    SET_POSITIONINGDEVICETYPE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_ModifyObjResult = rst
    },
    SET_POSITIONINGDEVICETYPE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_DeleteObjResult = rst
    },
    SET_POSITIONINGDEVICETYPE_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_AddProcessRemarkResult = rst
    },
    SET_POSITIONINGDEVICETYPE_UPLOADMAINTAINPICTURE_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_UploadMaintainPictureResult = rst
    },
    SET_POSITIONINGDEVICETYPE_REMOVEMAINTAINPICTURE_RESULT: (state, rst) => {
      state.state_PositioningDeviceType_RemoveMaintainPictureResult = rst
    }
  },
  actions: {
    PositioningDeviceTypeServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_SearchByName ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_SEARCHBYNAME_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_SEARCHBYNAME_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_AddProcessRemark ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_ADDPROCESSREMARK_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_ADDPROCESSREMARK_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_UploadMaintainPicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadMaintainPicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_UPLOADMAINTAINPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_UPLOADMAINTAINPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    PositioningDeviceTypeServ_RemoveMaintainPicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        removeMaintainPicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_POSITIONINGDEVICETYPE_REMOVEMAINTAINPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_POSITIONINGDEVICETYPE_REMOVEMAINTAINPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_PositioningDeviceType_AddObjResult: state => {
      return state.state_PositioningDeviceType_AddObjResult
    },
    get_PositioningDeviceType_GetAllResult: state => {
      return state.state_PositioningDeviceType_GetAllResult
    },
    get_PositioningDeviceType_SearchByNameResult: state => {
      return state.state_PositioningDeviceType_SearchByNameResult
    },
    get_PositioningDeviceType_GetPageResult: state => {
      return state.state_PositioningDeviceType_GetPageResult
    },
    get_PositioningDeviceType_GetDetailResult: state => {
      return state.state_PositioningDeviceType_GetDetailResult
    },
    get_PositioningDeviceType_ModifyObjResult: state => {
      return state.state_PositioningDeviceType_ModifyObjResult
    },
    get_PositioningDeviceType_DeleteObjResult: state => {
      return state.state_PositioningDeviceType_DeleteObjResult
    },
    get_PositioningDeviceType_AddProcessRemarkResult: state => {
      return state.state_PositioningDeviceType_AddProcessRemarkResult
    },
    get_PositioningDeviceType_UploadMaintainPictureResult: state => {
      return state.state_PositioningDeviceType_UploadMaintainPictureResult
    },
    get_PositioningDeviceType_RemoveMaintainPictureResult: state => {
      return state.state_PositioningDeviceType_RemoveMaintainPictureResult
    }
  }
}
